import { Button } from '@listening/frontend/components/radix/button';
import { cn } from '@listening/utils/react-helpers';
import * as m from '@/paraglide/messages';

export function CtaButton({
  className,
  onClick,
}: {
  className?: string;
  onClick: () => void;
}) {
  return (
    <Button
      className={cn(
        'h-auto rounded-full bg-azure-595 font-bold text-white shadow-[0_6px_18px_rgba(5,135,251,0.28)] hover:bg-azure-700 active:translate-y-px',
        className,
      )}
      onClick={onClick}
      type='button'
    >
      {m.homepage_hero_cta()}
    </Button>
  );
}
